var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientIconCog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_1071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 26V23L32.252 22.557C32.061 21.7947 31.7577 21.0651 31.352 20.392L33.336 17.782L31.218 15.661L28.608 17.645C27.9349 17.2393 27.2053 16.936 26.443 16.745L26 13.5H23L22.557 16.748C21.7947 16.939 21.0651 17.2423 20.392 17.648L17.782 15.661L15.661 17.782L17.645 20.392C17.2393 21.0651 16.936 21.7947 16.745 22.557L13.5 23V26L16.748 26.443C16.939 27.2053 17.2423 27.9349 17.648 28.608L15.664 31.218L17.785 33.339L20.395 31.355C21.0681 31.7607 21.7977 32.064 22.56 32.255L23 35.5H26L26.443 32.252C27.2053 32.061 27.9349 31.7577 28.608 31.352L31.218 33.336L33.339 31.215L31.355 28.605C31.7607 27.9319 32.064 27.2023 32.255 26.44L35.5 26Z",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.5C26.1569 27.5 27.5 26.1569 27.5 24.5C27.5 22.8431 26.1569 21.5 24.5 21.5C22.8431 21.5 21.5 22.8431 21.5 24.5C21.5 26.1569 22.8431 27.5 24.5 27.5Z",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_1071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIconCog);
export default __webpack_public_path__ + "static/media/patient-icon-cog.104451f1dd7fd69083dc51868cdde9df.svg";
export { ForwardRef as ReactComponent };